<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('TextTool', function() {
            return {
                group: 'Annotations', category: 'Annotations', icon: this.getIcon('text'),
                type: 'TextNote',
                name: 'Text',
                hint: 'Add Text Annotation',
                data: [],
                settings: { text: 'Note' },
                mods: {
                    'Label': {
                        settings: { label: true, text: 'Label' },
                        category: 'Annotations',
                        icon: this.getIcon('text'),
                        hint: 'Add Label',
                        name: 'Label'
                    }
                }
            }
        }, s => s.label ? 'Label' : 'Text')
</script>
